const reducer = (state, { type, payload }) => {
	// console.log('reducer:', type, payload);
	// console.log('reducer:'+type);
	switch (type) {
		case "LOAD_FAILED":
			return {
				...state,
				message: payload,
				rquireCheck: true,
				loading: false,
			}
		case "SET_STATE_DATA":
			return {
				...state,
				...payload,
			}
		case "SET_STATE":
			return payload
				
		case "CLEAR_STATE_DATA":
			return {}
		case "LOADING":
			return {
				...state,
				loading: true,
				message: undefined,
				rquireCheck: false,
				mobileNoError: undefined,
			}
		case "LOADED":
			return {
				...state,
				loading: false,
				rquireCheck: false,
				message: undefined,
				mobileNoError: undefined,
			}

		default:
			return state
	}
}
export default reducer;